import { render, staticRenderFns } from "./ScientificDegreeDelete.vue?vue&type=template&id=4e3ba95a&scoped=true&"
import script from "./ScientificDegreeDelete.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ba95a",
  null
  
)

export default component.exports